import { render, staticRenderFns } from "./ReassignModal.vue?vue&type=template&id=e7c55060&scoped=true"
import script from "./ReassignModal.vue?vue&type=script&lang=js"
export * from "./ReassignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c55060",
  null
  
)

export default component.exports